<div
  class="flex h-full flex-col gap-4 rounded-4xl border-2 border-background-white bg-background-modal px-6 py-4 shadow-modal backdrop-blur-modal"
>
  <h2 class="self-center text-h2 font-semibold">{{ 'collab_image_selector_modal_title' | translate }}</h2>
  <h4 class="self-center text-h4 font-light text-text-tertiary">{{ 'collab_image_selector_modal_subtitle' | translate }}</h4>
  <lib-button-group class="w-fit self-center">
    @for (element of navbarItems; track element) {
      <a libButtonGroupElement [active]="activeTab() === element" (click)="onTabSelected(navbarRecords[element]!)">{{
        'common_image_category_' + element | translate
      }}</a>
    }
  </lib-button-group>
  <div class="flex flex-1 flex-col gap-4 overflow-hidden rounded-3xl bg-background-white/60 backdrop-blur">
    <div class="flex flex-1 divide-x divide-text-extra-light overflow-hidden">
      <div class="flex h-full w-full flex-1 overflow-y-auto">
        @if (areImagesLoadingSignal()) {
          <ng-lottie
            [options]="lottieOptions"
            currentcolor
            class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-primary-blue"
          ></ng-lottie>
        } @else {
          @if (galleryItems(); as galleryItems) {
            <div class="flex w-full flex-col justify-between">
              @if (activeTab(); as activeTab) {
                @if (activeTab === GalleryItemTabs.FullSeries) {
                  <lib-full-series
                    class="h-full items-center justify-self-center px-6"
                    [fullSeries]="galleryItems[activeTab]"
                    [patientId]="dialogData.patientId"
                    [siteId]="dialogData.siteId"
                    [selectionMode]="true"
                    [selectedImageIds]="selectedImageIds()"
                    (imageSelectionChanged)="onImageSelectionChanged($event.images, $event.selected)"
                  />
                } @else {
                  @if (galleryItems[activeTab]) {
                    <div class="flex h-fit w-full flex-wrap gap-2 px-24 py-6">
                      @for (galleryItem of galleryItems[activeTab]; track galleryItem?.id) {
                        @if (galleryItem) {
                          <lib-imaging-image-card
                            [image]="galleryItem"
                            [patientId]="dialogData.patientId"
                            [siteId]="dialogData.siteId"
                            [selectionMode]="true"
                            [selectedImageIds]="selectedImageIds()"
                            (imageSelectionChanged)="onImageSelectionChanged([galleryItem], $event.selected)"
                          >
                            <div details class="flex items-center justify-between">
                              <lib-imaging-date-label class="flex-shrink-0 px-2 py-[5px]" [date]="galleryItem.date" />
                              <lib-tooth-position-label
                                class="flex-shrink-0 px-2 py-[5px]"
                                [toothPositions]="galleryItem.toothPositions"
                                [category]="galleryItem.category"
                                styleClass="typo-h6-light"
                              />
                            </div>
                          </lib-imaging-image-card>
                        }
                      }
                    </div>
                  } @else {
                    <div class="flex h-full w-full flex-col items-center justify-center gap-4">
                      <div class="flex items-center justify-center rounded-full bg-background-light-grey p-4">
                        <svg-icon [key]="'px-24-image'" class="text-text-light" />
                      </div>
                      <div class="typo-h4-light text-text-light">{{ 'collab_image_selector_modal_no_image' | translate }}</div>
                    </div>
                  }
                }
              }
              @if (currentTabImageIds().length > 1) {
                <div class="flex items-center gap-3 px-8 pb-6">
                  <div class="flex items-center gap-2">
                    <lib-checkbox [formControl]="selectAllImagesControl" />
                    <span class="typo-h4-light min-w-max text-text-primary">{{
                      'images_selection_select_all_button_title' | translate
                    }}</span>
                  </div>

                  <span class="typo-h5-book min-w-max text-text-light">
                    {{
                      (currentTabSelectedImageCount() > 1
                        ? 'collab_image_selector_modal_group_selected_plural'
                        : 'collab_image_selector_modal_group_selected'
                      ) | translate: { input1: currentTabSelectedImageCount() }
                    }}
                  </span>
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  </div>
  <div class="flex w-full items-center justify-end">
    @if (selectedImagesCount(); as selectedImagesCount) {
      <div class="absolute flex w-full justify-center">
        <div class="typo-h5-light flex items-center justify-center">
          <svg-icon key="px-24-tick" class="text-secondary-green"></svg-icon>
          <span class="text-text-tertiary">
            {{
              (selectedImagesCount > 1 ? 'collab_image_selector_modal_image_selected_plural' : 'collab_image_selector_modal_image_selected')
                | translate: { input1: selectedImagesCount }
            }}
          </span>
        </div>
      </div>
    }

    <div class="z-10 flex gap-10">
      <button
        class="btn-text"
        (click)="closeDialog()"
        [disabled]="areAttachmentsLoadingSignal()"
        [ffdPushTagOnClick]="{
          event: TagEvent.CollaborationSelectionCanceled
        }"
      >
        {{ 'collab_image_selector_modal_cancel' | translate }}
      </button>
      <button class="btn-primary" (click)="onAddSelections()" [disabled]="areAttachmentsLoadingSignal()">
        @if (areAttachmentsLoadingSignal()) {
          <ng-lottie [options]="lottieOptions"></ng-lottie>
        } @else {
          {{ 'collab_image_selector_modal_add' | translate }}
        }
      </button>
    </div>
  </div>
</div>
